import Moment from 'moment';
import _ from 'lodash';

const TicketService = {

    getJuniorTickets: function (details) {
        const contacts = _.map(details, (item) => {
            return item.contact;
        });
        const list = this.filterJuniors(contacts);
        return _.sortBy(list, ['surname'])
    },

    getSeniorTickets: function (details) {
        const contacts = _.map(details, (item) => {
            return item.contact;
        });
        const list = this.filterSeniors(contacts);
        return _.sortBy(list, ['surname'])
    },

    filterJuniors: function(contacts) {
        return _.filter(contacts, (item) => {
            const age = Moment().diff(item.birth_date, 'years', false);
            return age < 18;
        });
    },

    filterSeniors: function(contacts) {
        return _.filter(contacts, (item) => {
            const age = Moment().diff(item.birth_date, 'years', false);
            return age >= 18;
        });
    }
};

export default TicketService;
